export default __webpack_public_path__ + "static/media/Mark-6-HUD-Dock Icons.f1dc1a6a.jpg";